// Bounded undo history for the graph canvases (ENG-878).
//
// Each entry is a full { nodes, edges } snapshot taken IMMEDIATELY BEFORE a
// destructive change (node/edge deletion). One snapshot per delete GESTURE:
// the canvases push from ReactFlow's onBeforeDelete — which fires once with
// the complete pre-delete state — so a Delete-key removal of a node AND its
// attached edges is one history entry, not two.
//
// Snapshots hold the canvases' base node objects (render-time handler
// injection never reaches this state), so restoring them is a plain
// setNodes/setEdges — the editors' existing sync effects then propagate to
// the module graph refs and the localStorage autosave.
//
// Deliberately undo-only (no redo): the ticket's contract is that deleting
// nodes must be recoverable. Bounded so a long editing session can't grow
// memory without limit.

export function createGraphHistory(limit = 50) {
  const stack = []
  return {
    push(nodes, edges) {
      stack.push({ nodes, edges })
      if (stack.length > limit) stack.shift()
    },
    pop() {
      return stack.pop() ?? null
    },
    get size() {
      return stack.length
    },
    clear() {
      stack.length = 0
    },
  }
}

// True for the plain undo chord (Ctrl/Cmd+Z, no shift) fired OUTSIDE an
// editable field — typing undo inside a node's text input must keep the
// browser's native text undo.
export function isUndoKeyEvent(e) {
  if (!e || !(e.ctrlKey || e.metaKey) || e.shiftKey) return false
  if (String(e.key ?? '').toLowerCase() !== 'z') return false
  const t = e.target
  if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return false
  return true
}
